import {
  Apartment,
  Badge,
  ContactPhone,
  Domain,
  Email,
  Home,
  Info,
  Layers,
  Person
} from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Typography
} from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { APP_LINK } from '../../common/menu/menuItems/menuList';
import { fetchSecurityOfficer } from '../../redux/secuityOfficer/securityAction';

const ViewSecurityGuard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(fetchSecurityOfficer(id));
  }, [dispatch, id]);

  const SecurityOfficerState = useSelector(
    (state) => state?.securityOfficer?.fetchSecurityOfficer.data || {}
  );

  const handleBack = () => {
    navigate(APP_LINK.LISTECURITYGUARD)
  };

  const guard = {
    firstName: SecurityOfficerState.security_gaurd_name || "N/A",
    email: SecurityOfficerState.email || "N/A",
    address: SecurityOfficerState.address || "N/A",
    phoneNumber: SecurityOfficerState.phone_number || "N/A",
    status: SecurityOfficerState.status === 1 ? "Active" : "Inactive",
    securityLicenceNumber: SecurityOfficerState.security_license_number || "N/A",
    dateOfBirth: SecurityOfficerState.date_of_birth || "N/A",
    wardName: SecurityOfficerState.Ward?.ward_name || "N/A",
    blockName: SecurityOfficerState.Block?.block_name || "N/A",
    floorName: SecurityOfficerState.Floor?.floor_name || "N/A"
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "N/A") return "N/A";
    const dateParts = dateString.split("/");
    if (dateParts.length === 3) {
      return new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
    return "Invalid Date";
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'success';
      case 'inactive':
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <Box sx={{ maxWidth: "100vw", mx: 'auto', p: 2 }}>
       <Grid container spacing={2}>
        <Grid item xs={10}>
          
        </Grid>
         <Grid item xs={2} mb={2}>
            <Button variant="contained" color="error" onClick={handleBack} startIcon={<ArrowBackIcon />} >
              Back
            </Button>
          </Grid>
        </Grid>
      <Card elevation={3}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h5" component="div">
              <Person sx={{ verticalAlign: 'middle', mr: 1 }} />
              Guard Information
            </Typography>
            <Chip 
              label={guard.status} 
              color={getStatusColor(guard.status)} 
              icon={<Info />} 
              variant="outlined"
            />
          </Box>

          <Divider sx={{ mb: 3 }} />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Person sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Name
              </Typography>
              <Typography variant="body1" gutterBottom>
                {guard.firstName}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Email sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Email
              </Typography>
              <Typography variant="body1" gutterBottom>
                {guard.email}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Address
              </Typography>
              <Typography variant="body1" gutterBottom>
                {guard.address}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <ContactPhone sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Phone Number
              </Typography>
              <Typography variant="body1" gutterBottom>
                {guard.phoneNumber}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Badge sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Security Licence Number
              </Typography>
              <Typography variant="body1" gutterBottom>
                {guard.securityLicenceNumber}
              </Typography>
            </Grid>

            {/* Block information */}
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Domain sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Block
              </Typography>
              <Typography variant="body1" gutterBottom>
                {guard.blockName}
              </Typography>
            </Grid>

            {/* Floor information */}
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Layers sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Floor
              </Typography>
              <Typography variant="body1" gutterBottom>
                {guard.floorName}
              </Typography>
            </Grid>

            {/* Ward information */}
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Apartment sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Ward
              </Typography>
              <Typography variant="body1" gutterBottom>
                {guard.wardName}
              </Typography>
            </Grid>

            {/* <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <CalendarToday sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Date of Birth
              </Typography>
              <Typography variant="body1" gutterBottom>
                {formatDate(guard.dateOfBirth)}
              </Typography>
            </Grid> */}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ViewSecurityGuard;